import { useMutation } from 'react-query'

// Services
import { UpdateDocumentChunk } from 'services/api/Ai'

export default () => {
  const {
    mutate: updateDocumentChunk,
    data: updateDocumentChunkData,
    error: updateDocumentChunkError,
    isLoading: isUpdateDocumentChunkLoading,
    isSuccess: isUpdateDocumentChunkSuccess,
    isError: isUpdateDocumentChunkError,
  } = useMutation(UpdateDocumentChunk)

  return {
    updateDocumentChunk,
    updateDocumentChunkData,
    updateDocumentChunkError,
    isUpdateDocumentChunkLoading,
    isUpdateDocumentChunkSuccess,
    isUpdateDocumentChunkError,
  }
}
